import { formatData, getGaClientId } from '@common/Tracking';
import { getNavFromValue } from '@common/Tracking/NavFrom';
import { pushToDataLayer } from '@helpers/dataLayer';
import { isBooztmobile, isBooztletAndWebshop } from '@helpers/env';
import { getVisitorDataCookieAsObject } from '@helpers/visitor';

export const handleTracking = (config) => {
    if (isBooztmobile(config) && !isBooztletAndWebshop(config)) {
        const {
            browsing_country: browsingCountry,
            browsing_language: browsingLanguage,
            custom_data_source: customDataSource,
            network_status: networkStatus
        } = App.Config.GaTrackingData;
        const {
            page_type: pageType,
            page_path: pagePath
        } = App.Config.GaTrackingPage;
        const data = {
            event: 'ga_pageview',
            page_path: pagePath,
            page_title: document.title,
            client_id: getGaClientId(),
            pageType,
            networkStatus,
            customDataSource,
            browsingCountry,
            browsingLanguage,
            ...formatData(getVisitorDataCookieAsObject())
        };

        if (App.Config.Controller === 'listing') {
            data.nav_from = getNavFromValue();
        }

        pushToDataLayer(data);
    }
};
